import { useState, useEffect } from 'react'
import { LuxMultiSelect } from '@lux/wardrobe-lib'
import { GalleryService } from '@/app/services/GalleryService'

interface SpecialCollectionsMultiselectProps {
    onChange: (val: string[]) => void
    value: string[]
}

const SpecialCollectionsMultiselect = ({ onChange, value }: SpecialCollectionsMultiselectProps) => {
    const [options, setOptions] = useState<{ label: string; value: string }[]>([])

    useEffect(() => {
        // Fetch options from the service
        GalleryService.GetSpecialCollections()
            .then((data) => setOptions(data))
            .catch((error) => console.error('Failed to fetch options:', error))
    }, [])

    return (
        <div>
            <LuxMultiSelect
                value={value}
                options={options}
                onChangeCallback={onChange}
                containerClasses="w-100"
            />
        </div>
    )
}

export default SpecialCollectionsMultiselect
